import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const DoNotContact = props => (
    <SvgIcon {...props}>
        <path
            fillRule="evenodd"
            stroke="none"
            d="M11.281 1.29c1.37.597 1.045 2.597.523 3.944l.024.015c.153.097.942.712-.438 2.363l-.01.053c-.038.21-.219.997-.834 1.563l-.005.02c-.024.111-.112.676.341 1.47L9.54 12.07c-.89.896-1.955 1.96-2.285 2.267l-.1.092c-.448.415-.467.538-.467 1.567H.02c-.114-.797.26-1.49 1.124-2.08 1.295-.883 3.798-2.09 4.303-2.53.505-.438.724-1.198.724-2.159l-.032-.033c-.14-.151-.692-.792-.692-1.514l-.046-.05c-.257-.288-1.485-1.763-.319-2.397l-.038-.13c-.133-.469-.55-2.087-.181-2.807l.026-.05C5.327 1.415 6.17.38 8.114.36h.06c2.029 0 1.738.332 3.107.93zM16 4.77v7.44c-.338.178-.01.805-.948.822h-.04c-.987 0-.793.55-.793 1.065 0 .497-.5.616-.975.623h-.053c-.479 0-.92.252-.936.682v.594H8.598l5.081-5.128-.292-.31-4.946 4.875v.563H7.413v-.84l5.778-5.929c-.936-1.842.712-4.457 2.809-4.457zm0 9.517l-.001.022a1.756 1.756 0 01-1.755 1.687H13.01v-.34c0-.111.09-.2.2-.2h.451c.251 0 1.17-.21 1.196-1.128v-.04-.55c.437.095.818.279 1.143.55z"
        />
    </SvgIcon>
);

export default DoNotContact;
